export const accountStates = {
    ACTIVE: 1,
    IN_ACTIVE: 2
}

export const accountHelper = {
    methods: {
        getAccountInUseStates: function () {
            return [
                {name: this.$t('account.active'), value: accountStates.ACTIVE},
                {name: this.$t('account.in_active'), value: accountStates.IN_ACTIVE},
            ]
        },
        newAccount: function (like) {
            if (!like) {
                // Return a default object if like is null or undefined
                return {
                    id: -1,
                    name: null,
                    code: null,
                    company: {id: null},
                    active: true, // or any other default value you prefer
                    sanction_account: false
                };
            }

            return {
                id: like.id ? like.id : -1,
                name: like.name,
                code: like.code,
                company: like.company ? like.company : {id: null},
                active: like.active,
                sanction_account: like.sanction_account ?? false,
                ...like
            };
        }

    }

}
